import { computed, MaybeRef, unref } from 'vue'
import { useQuery } from '@vue/apollo-composable'
import { CustomFieldTypeValueInput, RateType } from '@/gql/graphql'
import { CompanyRateCardBandQuery } from '@/components/Job/graphql/queries'

// For a job the company has not saved yet — same debounce and enabled behaviour as useJobRateCardBandQuery.
export function useCompanyRateCardBandQuery(options: {
  companyId: MaybeRef<string | null | undefined>
  customFieldValues: MaybeRef<CustomFieldTypeValueInput[]>
  rate: MaybeRef<string | number>
  rateType: MaybeRef<RateType>
  enabled: MaybeRef<boolean>
}) {
  const { result, loading } = useQuery(
    CompanyRateCardBandQuery,
    () => ({
      companyId: unref(options.companyId)!,
      customFieldValues: unref(options.customFieldValues),
      rate: unref(options.rate),
      rateType: unref(options.rateType),
    }),
    () => ({
      clientId: 'publicApi',
      debounce: 400,
      enabled: unref(options.enabled) && !!unref(options.companyId),
    }),
  )

  const band = computed(() =>
    unref(options.enabled) ? (result.value?.company?.rateCardBand ?? null) : null,
  )

  return { band, loading }
}
